import { theme, typographyRem } from '@by-miles/bymiles-styles'
import dayjs from 'dayjs'
import React from 'react'
import styled from 'styled-components'

import { useQuote } from '../../hooks/useQuote'
const { labelMedium: LabelMedium, paragraphBody: ParagraphBody } = typographyRem

const CarDetailsStyle = styled.div`
  .car-data {
    margin-bottom ${theme.grid.spacing.md}px;
  }
`

const getTransmission = (trans: string) => {
  if (!trans) {
    return 'Unknown'
  } else {
    return trans === 'A' ? 'Automatic' : 'Manual'
  }
}

interface CarDetailsComponentProps {
  className: string
}

export const CarDetailsComponent = ({ className }: CarDetailsComponentProps) => {
  const quote = useQuote()
  return (
    <CarDetailsStyle className={className}>
      <div className="car-details">
        <LabelMedium>Year of manufacture</LabelMedium>
        <ParagraphBody className="car-data">
          {dayjs(quote?.details?.vehicle?.manufacture_date).format('YYYY')}
        </ParagraphBody>
        <LabelMedium>Transmission type</LabelMedium>
        <ParagraphBody className="car-data">
          {getTransmission(quote?.details?.vehicle?.transmission || '')}
        </ParagraphBody>
        <LabelMedium>Imported</LabelMedium>
        <ParagraphBody className="car-data">{quote?.details?.vehicle?.is_import ? 'Yes' : 'No'}</ParagraphBody>
      </div>
      <div className="car-details">
        <LabelMedium>Engine size</LabelMedium>
        <ParagraphBody className="car-data">{`${
          quote?.details?.vehicle?.size === 0 ? 'n/a' : `${quote?.details?.vehicle?.size}cc`
        }`}</ParagraphBody>
        <LabelMedium>Fuel type</LabelMedium>
        <ParagraphBody className="car-data">{quote?.details?.vehicle?.fuel}</ParagraphBody>
        <LabelMedium>Steering</LabelMedium>
        <ParagraphBody>{`${quote?.details?.vehicle?.is_rhd ? 'Right' : 'Left'}-hand drive`}</ParagraphBody>
      </div>
    </CarDetailsStyle>
  )
}
